/* Gift cart synchronization. Storefront checks are not checkout enforcement. */
(() => {
  'use strict';
  if (typeof module !== 'undefined' && module.exports) { module.exports = {plan}; return; }
  if (window.OumoFreeGift) return;
  const root = (window.Shopify?.routes?.root || '/');
  let pending = null, dirty = false, timer, passingCheckout = false;

  function plan(state, exchangeRate) {
    const rate = state.currency === 'USD' ? 1 : Number(exchangeRate);
    if (!Number.isFinite(rate) || rate <= 0 || !Number.isSafeInteger(state.eligible) || state.eligible < 0) throw new Error('Gift currency unavailable');
    const updates = {}, items = [];
    const tiers = [{id:67723604263162, threshold:9900}, {id:67723604295930, threshold:15000}];
    for (const tier of tiers) {
      const product = state.products.find(p => p.id === tier.id);
      const qualified = state.eligible >= Math.round(tier.threshold * rate) && product?.available === true && product.price === 0;
      const lines = state.gifts.filter(g => g.id === tier.id);
      lines.forEach((gift, index) => {
        const quantity = qualified && index === 0 ? 1 : 0;
        if (gift.quantity !== quantity) updates[gift.key] = quantity;
      });
      if (qualified && !lines.length) items.push({id:tier.id, quantity:1, properties:{_oumo_free_gift:'true'}});
    }
    return {items, updates};
  }

  async function read() {
    const response = await fetch(root + 'cart?view=oumo-gift', {cache:'no-store', headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error('Gift eligibility unavailable');
    const state = JSON.parse(await response.text());
    if (!Array.isArray(state.gifts) || !Array.isArray(state.products)) throw new Error('Invalid gift state');
    return state;
  }

  async function mutate(action) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles:true,detail:{sections}}));
    const adding = Object.keys(action.updates).length === 0;
    const data = adding ? {items:action.items} : {updates:action.updates};
    data.sections = [...new Set(sections)].slice(0,5);
    data.sections_url = window.location.pathname;
    const response = await fetch(root + (adding ? 'cart/add.js' : 'cart/update.js'), {
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('Gift update unavailable');
    const fresh = await fetch(root + 'cart.js', {cache:'no-store'});
    if (!fresh.ok) throw new Error('Cart refresh unavailable');
    const cart = await fresh.json();
    cart.sections = result.sections;
    const pubsub = window.FoxTheme?.pubsub;
    if (pubsub) pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, {sources:'oumo-free-gift',cart});
    else document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function sync() {
    dirty = true;
    if (pending) return pending;
    pending = (async () => {
      let passes = 0;
      do {
        dirty = false;
        const action = plan(await read(), window.Shopify?.currency?.rate);
        if (action.items.length || Object.keys(action.updates).length) {
          await mutate(action);
          dirty = true; // Recheck live eligibility after the cart mutation.
        }
        if (++passes > 5 && dirty) throw new Error('Cart changed during gift sync');
      } while (dirty);
    })().finally(() => {pending = null;});
    return pending;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => sync().catch(() => {}), 120);
  }

  function start() {
    const pubsub = window.FoxTheme?.pubsub;
    if (pubsub) pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.sources !== 'oumo-free-gift') schedule();
    });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    // Wait for the last eligibility check on the ordinary checkout button.
    document.addEventListener('click', async event => {
      const trigger = event.target.closest?.('[name="checkout"],a[href="/checkout"]');
      if (!trigger || passingCheckout) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      trigger.setAttribute('aria-busy','true');
      try {
        await sync();
        passingCheckout = true;
        if (trigger.tagName === 'A') window.location.assign(trigger.href);
        else if (trigger.form) trigger.form.requestSubmit(trigger);
        else window.location.assign(root + 'checkout');
      } catch (_) {
        const message = document.querySelector('[data-gift-message]');
        if (message) {message.textContent = 'Please try checkout again — your cart could not be refreshed.';message.setAttribute('role','alert');}
      } finally {
        trigger.removeAttribute('aria-busy');
        passingCheckout = false;
      }
    }, true);
    schedule();
  }
  window.OumoFreeGift = {sync};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();

